import { useLocation } from 'react-router-dom';

const useCustomerDomain = (): string => {
  const location = useLocation();
  return location.pathname.split('/')[1];
};

export default useCustomerDomain;
